export const getToken = () => localStorage.getItem('token');

export const apiFetch = (url, opts = {}) => fetch(url, {
  ...opts,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getToken()}`,
    ...(opts.headers || {}),
  },
});
